import React, { useState } from 'react';
import { BulkRemoveLeadsProps } from './leadsModels';
import { TrashIcon } from '../../../assets';
import { useAppData } from '../../../context/AppContext';
import { ConfirmModal, InfoModal } from '../../../components';
import { removeLeadsByIds } from '../../../core/requests/requests';

const BulkRemoveLeads: React.FC<BulkRemoveLeadsProps> = ({
  selectedLeadIds,
  setSelectedLeadIds,
  refetchLeads,
}) => {
  const { setShowModalBackground } = useAppData();
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [infoMessage, setInfoMessage] = useState('');

  const handleShowConfirmModal = () => {
    setConfirmModalOpen(true);
    setShowModalBackground(true);
  };

  const handleCloseAll = () => {
    setInfoMessage('');
    setSelectedLeadIds([]);
    refetchLeads();
    setShowModalBackground(false);
  };

  const handleBulkRemoveLeads = async () => {
    try {
      const { data } = await removeLeadsByIds(selectedLeadIds);
      if (data.success) {
        setConfirmModalOpen(false);
        //
        setInfoMessage('Leads removed successfully');
        setTimeout(() => {
          handleCloseAll();
        }, 2000);
      }
    } catch (error) {
      console.error(error);
      setConfirmModalOpen(false);
      setInfoMessage('Error removing leads');
      setTimeout(() => {
        setInfoMessage('');
        setShowModalBackground(false);
      }, 2000);
    }
  };

  const selectionCount = selectedLeadIds.length;
  const selectionText =
    selectionCount === 1
      ? '1 lead selected'
      : `${selectionCount} leads selected`;
  const confirmText =
    selectionCount === 1
      ? 'Are you sure you want to remove this lead?'
      : `Are you sure you want to remove these ${selectionCount} leads?`;

  return (
    <>
      <div className="bulk-remove-leads-bar">
        <span className="bulk-remove-leads-selection-text">
          {selectionText}
        </span>
        <button
          className="bulk-remove-leads-btn-delete"
          onClick={handleShowConfirmModal}
        >
          <TrashIcon className="bulk-remove-leads-icon" /> Delete Selected
        </button>
      </div>

      {isConfirmModalOpen && (
        <div className="bulk-remove-leads-modal-overlay">
          <ConfirmModal
            title={confirmText}
            onConfirm={handleBulkRemoveLeads}
            onCancel={handleCloseAll}
          />
        </div>
      )}

      {infoMessage && (
        <div className="bulk-remove-leads-modal-overlay">
          <InfoModal title={infoMessage} onClose={handleCloseAll} />
        </div>
      )}
    </>
  );
};

export default BulkRemoveLeads;
